import React,{ Component } from 'react';
import Navigation from '../../components/navigation'
import bg1 from './../../images/1.png'
import {Link} from 'react-router-dom'
import arrowLeft from './../../images/arrow-bgblack-left.png'
import arrowRight from './../../images/arrow-right.png'
import playOS from './../../images/play_circle_orange_s.png'
import './star.css'
export default class star extends Component {
    render(){
        return (
            <main>
                <Navigation tab="match"></Navigation>
                <div className="detail_title"><Link to="/match">赛事</Link> / 击剑明星</div>
                {this.props.match.params.id == 0 &&
                    <div className="star_detail">
                        <div className="star_info">
                            <div className="avatar">
                                <img src={require('./../../pic/lehuilin.jpg')} alt=""></img>
                            </div>
                            <div className="info">
                                <p>乐慧林</p>
                                <p>中国击剑队女子花剑运动员</p>
                                <p>生日：1989年4月1日 出生于福建省三明市</p>
                                <p>2010年，乐慧林入选中国击剑队。2010年，在广州亚运会击剑比赛中，乐慧林获得女子花剑团体季军。2011年4月，在亚洲击剑锦标赛中，乐慧林获得女子花剑个人、团体季军。2014年9月，在仁川亚运会击剑比赛中，乐慧林获得女子花剑个人、团体亚军。2016年4月，在亚洲击剑锦标赛中，乐慧林获得女子花剑团体冠军；8月，在里约热内卢奥运会击剑比赛中，乐慧林不敌对手止步16强。</p>
                            </div>
                        </div>
                        <div className="recent_games heroic_moment">
                            <p>她的近期比赛</p>
                            <div className="event">
                                <ul>
                                    <div>
                                        <li><Link to={"/video/x03054ms6rg/1"}>
                                            <p>2016国际剑联花剑世界杯大奖赛</p>
                                            <p style={{color:'#FF5D38'}}>2016年6月3日至5日</p>
                                            <p>上海</p>
                                        </Link></li>
                                    </div>
                                </ul>
                            </div>
                            <p>她的英雄时刻</p>
                            <ul className="list">
                                <Link to={"/video/x03054ms6rg/1"}>
                                    <li>
                                        <img src={require("./../../pic/lehuilin_match_01.png")} alt=""></img><p>2016国际剑联上海花剑大奖赛</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：95</span>
                                        </div>
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                }
                {this.props.match.params.id == 1 &&
                    <div className="star_detail">
                        <div className="star_info">
                            <div className="avatar">
                                <img src={require('./../../pic/linsheng.jpg')} alt=""></img>
                            </div>
                            <div className="info">
                                <p>林声</p>
                                <p>中国击剑运动员</p>
                                <p>出生在福州盖山</p>
                                <p>2018年3月，在2018年国际剑联重剑世界杯大奖赛（西班牙站）摘得个人赛银牌。2018年7月25日，2018年世界击剑锦标赛，由许诚子、朱明叶、林声和孙一文组成的团体获得铜牌。2018年8月6日，入选第十八届亚运会中国体育代表团名单。2018年8月24日，2018年雅加达亚运会女子重剑团体赛的争夺，由朱明叶、孙一文、林声和许诚子组成的中国队以29-28险胜韩国队夺冠，成功卫冕。2019年7月22日，在匈牙利布达佩斯举行的2019年世界击剑锦标赛女子重剑团体赛中，由孙一文、许安琪、朱明叶和林声组成的中国女子重剑团体在决赛中以29比28战胜俄罗斯队摘得金牌。</p>
                            </div>
                        </div>
                        <div className="recent_games heroic_moment">
                            <p>她的近期比赛</p>
                            <div className="event">
                                <ul>
                                    <div> 
                                        <li><Link to={"/video/w07459h9de8/1"}>
                                            <p>2018世界击剑锦标赛</p>
                                            <p style={{color:'#FF5D38'}}>2018年7月19日至27日</p>
                                            <p>无锡</p>
                                        </Link></li>
                                    </div>
                                </ul>
                            </div>
                            <p>她的英雄时刻</p>
                            <ul className="list">
                                <Link to={"/video/w07459h9de8/1"}>
                                    <li>
                                        <img src={require("./../../pic/linsheng_match_01.png")} alt=""></img><p>2018击剑世锦赛 女重个人 林声 vs KOR</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：95</span>
                                        </div>
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                }
                {this.props.match.params.id == 2 &&
                    <div className="star_detail">
                        <div className="star_info">
                            <div className="avatar">
                                <img src={require('./../../pic/sunyiwen.jpg')} alt=""></img>
                            </div>
                            <div className="info">
                                <p>孙一文</p>
                                <p>中国击剑队女子重剑运动员</p>
                                <p>生日：1992年6月17日 出生于山东省烟台市</p>
                                <p>2005年，孙一文进入烟台市击剑队。2006年，孙一文入选中国击剑队。2013年5月，在国际剑联女子重剑世界杯大奖赛中，孙一文等代表的中国队获得女子重剑团体冠军。2014年9月，在韩国仁川亚运会女子重剑比赛中，孙一文获得女子重剑团体冠军。2015年10月，在意大利击剑世界杯比赛中，孙一文获得女子重剑个人冠军。2016年8月，在里约热内卢奥运会女子重剑比赛中，孙一文获得个人铜牌、团体银牌。
2019年7月22日，在匈牙利布达佩斯举行的2019年世界击剑锦标赛女子重剑团体赛中，由孙一文、许安琪、朱明叶和林声组成的中国女子重剑团体在决赛中以29比28战胜俄罗斯队摘得金牌。10月，孙一文获得第七届世界军人运动会女子重剑冠军。</p>
                            </div>
                        </div>
                        <div className="recent_games heroic_moment">
                            <p>她的近期比赛</p>
                            <div className="event">
                                <ul>
                                    <div> 
                                        <li><Link to={"/video/k30105ua5t5/1"}>
                                            <p>第七届世界军人运动会</p>
                                            <p style={{color:'#FF5D38'}}>2019年10月18日至27日</p>
                                            <p>武汉</p>
                                        </Link></li>
                                        <li><Link to={"/video/r3017ax0ge4/1"}>
                                            <p>2018-2019国际剑联</p>
                                            <p style={{color:'#FF5D38'}}>2018年11月11日</p>
                                            <p>塔林</p>
                                        </Link></li>
                                        <li><Link to={"/video/f0547oqk6x0/1"}>
                                            <p>2017第十三届全运会</p>
                                            <p style={{color:'#FF5D38'}}>2017年8月27日～9月8日</p>
                                            <p>天津</p>
                                        </Link></li>
                                        <li><Link to={"/video/q0867iwfnkh/1"}>
                                            <p>2019哥伦比亚重剑大奖赛</p>
                                            <p style={{color:'#FF5D38'}}>2019年5月3日-5月5日</p>
                                            <p>赛卡利站</p>
                                        </Link></li>
                                    </div>
                                </ul>
                            </div>
                            <p>她的英雄时刻</p>
                            <ul className="list">
                                <Link to={"/video/k30105ua5t5/1"}>
                                    <li>
                                        <img src={require("./../../pic/sunyiwen_match_01.png")} alt="孙一文军运会夺金"></img><p>孙一文军运会夺金</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：35</span>
                                        </div>
                                    </li>
                                </Link>
                                <Link to={"/video/r3017ax0ge4/1"}>
                                    <li>
                                        <img src={require("./../../pic/sunyiwen_match_02.png")} alt="2020赛季女重世界杯塔林 半决 孙一文vs波佩斯库"></img><p>2020赛季女重世界杯塔林 半决</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：124</span>
                                        </div>
                                    </li>
                                </Link>
                                <Link to={"/video/f0547oqk6x0/1"}>
                                    <li>
                                        <img src={require("./../../pic/sunyiwen_match_03.png")} alt="孙一文全运会女团冠军"></img><p>孙一文全运会女团冠军</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：53</span>
                                        </div>
                                    </li>
                                </Link>
                                <Link to={"/video/q0867iwfnkh/1"}>
                                    <li>
                                        <img src={require("./../../pic/sunyiwen_match_04.png")} alt="2019哥伦比亚重剑大奖赛 - 女重个人决赛 - 孙一文"></img><p>2019哥伦比亚重剑大奖赛 - 女重个人决赛 - 孙一文</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：82</span>
                                        </div>
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                }
                {this.props.match.params.id == 3 &&
                    <div className="star_detail">
                        <div className="star_info">
                            <div className="avatar">
                                <img src={require('./../../pic/xuanqi.jpg')} alt=""></img>
                            </div>
                            <div className="info">
                                <p>许安琪</p>
                                <p>中国女子重剑队队员</p>
                                <p>生日：1992年1月23日   出生于江苏南京</p>
                                <p>2009年许安琪破格进入国家队，并参加世锦赛获得亚锦赛女重团体亚军；2012年8月5日，许安琪在伦敦奥运会团体决赛中以39比25战胜韩国队，为中国夺取奥运会上的击剑团体第一枚金牌；2015年1月25日，许安琪在重剑世界杯个人赛中获得金牌。
2016年8月6日，2016年里约奥运会击剑项目展开首日较量。女子重剑个人赛，许安琪以8-15不敌法国人玛丽-佛罗伦萨，最终出局。8月12日，里约奥运会女子重剑团体银牌。2017年第十三届全运会击剑女子重剑个人赛冠军。
2019年7月22日，在匈牙利布达佩斯举行的2019年世界击剑锦标赛女子重剑团体赛中，由孙一文、许安琪、朱明叶和林声组成的中国女子重剑团体在决赛中以29比28战胜俄罗斯队摘得金牌。</p>
                            </div>
                        </div>
                        <div className="recent_games heroic_moment">
                            <p>她的近期比赛</p>
                            <div className="event">
                                <ul>
                                    <div> 
                                        <li><Link to={"/video/m0194k9kzyc/1"}>
                                            <p>2016年亚洲击剑锦标赛</p>
                                            <p style={{color:'#FF5D38'}}>2016年4月11日——18日</p>
                                            <p>无锡</p>
                                        </Link></li>
                                        <li><Link to={"/video/p0553qh9axv/1"}>
                                            <p>2017第十三届全运会</p>
                                            <p style={{color:'#FF5D38'}}>2017年8月27日-9月8日</p>
                                            <p>天津</p>
                                        </Link></li>
                                    </div>
                                </ul>
                            </div>
                            <p>她的英雄时刻</p>
                            <ul className="list">
                                <Link to={"/video/m0194k9kzyc/1"}>
                                    <li>
                                        <img src={require("./../../pic/xuanqi_match_01.png")} alt="
2016亚洲击剑锦标赛女子重剑个人决赛-孙玉洁VS许安琪"></img><p>
2016亚洲击剑锦标赛女子重剑个人决赛-孙玉洁VS许安琪</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：95</span>
                                        </div>
                                    </li>
                                </Link>
                                <Link to={"/video/p0553qh9axv/1"}>
                                    <li>
                                        <img src={require("./../../pic/xuanqi_match_02.png")} alt="
第十三届全运会击剑女子重剑个人决赛 郝佳露VS许安琪"></img><p>
第十三届全运会击剑女子重剑个人决赛 郝佳露VS许安琪</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：95</span>
                                        </div>
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                }
                {this.props.match.params.id == 4 &&
                    <div className="star_detail">
                        <div className="star_info">
                            <div className="avatar">
                                <img src={require('./../../pic/zhuyeming.jpg')} alt=""></img>
                            </div>
                            <div className="info">
                                <p>朱明叶</p>
                                <p>中国女子击剑运动员</p>
                                <p>生日：1992年1月   出生于广东云浮市罗定</p>
                                <p>2004年8月－2008年8月在云浮市中心体校击剑班训练，2008年9月输送到省体校击剑班训练，2010年3月输送到省击剑队成为正式运动员，现任国家击剑队女子重剑主力队员。
2017年6月，2017年亚洲击剑锦标赛朱明叶获得女子重剑个人赛的铜牌。2017年10月22日，在国际剑联2017-2018赛季女子重剑世界杯第一站中，朱明叶获得团体赛铜牌 。2018年2月，国际剑联女子重剑世界杯分站赛西班牙巴塞罗那站，朱明叶获得个人赛冠军。2018年8月24日，2018年雅加达亚运会女子重剑团体赛，朱明叶获得团体赛冠军。
2019年6月14日，国家女子重剑主力队员朱明叶在日本东京千叶港竞技中心举行的2019亚洲击剑锦标赛上获得了个人女子重剑冠军，这是她继2018年2月巴塞罗那世界杯击剑赛后再次获得国际性赛事该项目个人冠军。2019年7月22日，在匈牙利布达佩斯举行的2019年世界击剑锦标赛女子重剑团体赛中，由孙一文、许安琪、朱明叶和林声组成的中国女子重剑团体在决赛中以29比28战胜俄罗斯队摘得金牌。</p>
                            </div>
                        </div>
                        <div className="recent_games heroic_moment">
                            <p>她的近期比赛</p>
                            <div className="event">
                                <ul>
                                    <div> 
                                        <li><Link to={"/video/l0551biltf7/1"}>
                                            <p>2018重剑世界杯</p>
                                            <p style={{color:'#FF5D38'}}>2018年2月14日</p>
                                            <p>巴塞罗那</p>
                                        </Link></li>
                                    </div>
                                </ul>
                            </div>
                            <p>她的英雄时刻</p>
                            <ul className="list">
                                <Link to={"/video/l0551biltf7/1"}>
                                    <li>
                                        <img src={require("./../../pic/zhumingye_match_01.png")} alt="
2018重剑世界杯巴塞罗那站决赛朱明叶夺冠"></img><p>
2018重剑世界杯巴塞罗那站决赛朱明叶夺冠</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：76</span>
                                        </div>
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                }
                {this.props.match.params.id == 5 &&
                    <div className="star_detail">
                        <div className="star_info">
                            <div className="avatar">
                                <img src={require('./../../pic/xuyingming.jpg')} alt=""></img>
                            </div>
                            <div className="info">
                                <p>许英明</p>
                                <p>中国击剑队男子佩剑运动员、佩剑队队长</p>
                                <p>生日：1992年1月22日   出生于广东省广州市</p>
                                <p>2010年，许英明入选广东省击剑队。2011年，许英明获全国击剑冠军赛男子佩剑个人赛亚军。2013年，许英明入选国家击剑队。2014年9月，许英明在仁川亚运会男子佩剑团体比赛中获得铜牌。2015年12月，许英明在全国击剑冠军赛总决赛上夺得成年组男子佩剑团体、个人两项冠军。2016年4月，许英明在亚锦赛男子佩剑个人赛中获铜牌；5月，许英明在国际剑联佩剑大奖赛莫斯科站中获男子个人亚军。2018年8月23日，许英明和队友在雅加达亚运会男子佩剑团体赛的争夺中获得铜牌。</p>
                            </div>
                        </div>
                        <div className="recent_games heroic_moment">
                            <p>他的近期比赛</p>
                            <div className="event">
                                <ul>
                                    <div> 
                                        <li><Link to={"/video/k0729xsmp8j/1"}>
                                            <p>2018击剑世锦赛</p>
                                            <p style={{color:'#FF5D38'}}>2018年7月19日至27日</p>
                                            <p>无锡</p>
                                        </Link></li>
                                    </div>
                                </ul>
                            </div>
                            <p>他的英雄时刻</p>
                            <ul className="list">
                                <Link to={"/video/k0729xsmp8j/1"}>
                                    <li>
                                        <img src={require("./../../pic/xuyingming_match_01.png")} alt="击剑世锦赛：男子佩剑中国选手全部晋级淘汰赛，许英明6战6胜"></img><p>击剑世锦赛：男子佩剑中国选手全部晋级淘汰赛，许英明6战6胜</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：95</span>
                                        </div>
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                }
                {this.props.match.params.id == 6 &&
                    <div className="star_detail">
                        <div className="star_info">
                            <div className="avatar">
                                <img src={require('./../../pic/sunwei.jpg')} alt=""></img>
                            </div>
                            <div className="info">
                                <p>孙伟</p>
                                <p>中国击剑队男子佩剑运动员</p>
                                <p>生日：1992年10月27日   出生于江苏徐州</p>
                                <p>2002年，孙伟进入徐州市少年儿童体校击剑队训练。2005年，孙伟进入江苏省击剑队。2008年入选国家击剑队。2009年，孙伟获得全国击剑锦标赛男子佩剑个人亚军 。2010年，孙伟获得全国青年击剑锦标赛男子佩剑个人、团体冠军 。2013年在西班牙马德里击剑世界杯中，孙伟获得男子佩剑团体亚军。2014年在仁川亚运会击剑男子佩剑个人赛中，孙伟收获一枚铜牌 。2015年在全国大学生击剑锦标赛中，孙伟获得男子佩剑个人季军、团体冠军 。2016年8月，在里约热内卢奥运会击剑男子佩剑个人赛中，孙伟不敌对手止步32强 。</p>
                            </div>
                        </div>
                        <div className="recent_games heroic_moment">
                            <p>他的近期比赛</p>
                            <div className="event">
                                <ul>
                                    <div> 
                                        <li><Link to={"/video/g08062ooryv/1"}>
                                            <p>2018中国击剑俱乐部联赛</p>
                                            <p style={{color:'#FF5D38'}}>2018年11月30日</p>
                                            <p>启东圆陀角</p>
                                        </Link></li>
                                    </div>
                                </ul>
                            </div>
                            <p>他的英雄时刻</p>
                            <ul className="list">
                                <Link to={"/video/g08062ooryv/1"}>
                                    <li>
                                        <img src={require("./../../pic/sunwei_match_01.png")} alt="2018俱乐部击剑总决赛孙伟"></img><p>2018俱乐部击剑总决赛孙伟</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：95</span>
                                        </div>
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                }
                {this.props.match.params.id == 7 &&
                    <div className="star_detail">
                        <div className="star_info">
                            <div className="avatar">
                                <img src={require('./../../pic/shijialuo.jpg')} alt=""></img>
                            </div>
                            <div className="info">
                                <p>施嘉洛</p>
                                <p>中国击剑队男子花剑运动员</p>
                                <p>生日：1993年1月25日   出生于福建晋江</p>
                                <p>2012年，施嘉洛获得全国击剑锦标赛男子花剑个人亚军、团体亚军。2013年，获得亚洲青年击剑锦标赛花剑个人赛冠军，第六届东亚运动会花剑个人赛冠军、男子花剑团体亚军。2014年，获得世界击剑锦标赛男子花剑团体亚军。2015年，获得男子花剑世界杯赛亚军，全国击剑冠军赛男子花剑团体赛冠军 、个人赛冠军。2016年8月，参加里约热内卢奥运会击剑比赛。2017年1月，被授予2016年度体育运动一级奖章。</p>
                            </div>
                        </div>
                        <div className="recent_games heroic_moment">
                            <p>他的近期比赛</p>
                            <div className="event">
                                <ul>
                                    <div> 
                                        <li><Link to={"/video/f0384si8eyf/1"}>
                                            <p>2016-2017赛季全国击剑冠军赛</p>
                                            <p style={{color:'#FF5D38'}}>2017年3月14日</p>
                                            <p>云南曲靖</p>
                                        </Link></li>
                                    </div>
                                </ul>
                            </div>
                            <p>他的英雄时刻</p>
                            <ul className="list">
                                <Link to={"/video/f0384si8eyf/1"}>
                                    <li>
                                        <img src={require("./../../pic/shiluojia_match_01.png")} alt="晋江击剑小将施嘉洛率福建男花夺冠"></img><p>晋江击剑小将施嘉洛率福建男花夺冠</p>
                                        <div className="play">
                                            <img src={playOS} alt=""></img>
                                            <span>播放量：95</span>
                                        </div>
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                }
            </main>
        )
    }
};